var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["contentful/text-over-image-component.j2"] = require( "contentful/text-over-image-component.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/text-over-image-component-outer.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.value[0]"]));
frame.set("recPlacementId", t_1, true);
if(frame.topLevel) {
context.setVariable("recPlacementId", t_1);
}
if(frame.topLevel) {
context.addExport("recPlacementId", t_1);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "recPlacementId")) {
output += "\n    ";
var t_2;
t_2 = env.getFilter("replace").call(context, runtime.contextOrFrameLookup(context, frame, "recPlacementId"),".","__");
frame.set("recPlacementKey", t_2, true);
if(frame.topLevel) {
context.setVariable("recPlacementKey", t_2);
}
if(frame.topLevel) {
context.addExport("recPlacementKey", t_2);
}
output += "\n    <div class=\"dom-rr-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "recPlacementKey"), env.opts.autoescape);
output += "\">\n        <span\n            class=\"dom-rr-container\"\n            data-rr-placement=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "recPlacementId"), env.opts.autoescape);
output += "\"\n            data-is-dy=\"true\"\n        >\n        ";
output += "\n        </span>\n    </div>\n";
;
}
else {
output += "\n    ";
env.getTemplate("contentful/text-over-image-component.j2", false, "core/templates/contentful/text-over-image-component-outer.j2", null, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
t_3.render(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
output += t_4
output += "\n";
})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/text-over-image-component-outer.j2"] , dependencies)